import { useState } from 'react'
import { Link as LinkIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { DJENPublication } from '@/types/publication'
import { LinkCaseModal } from './LinkCaseModal'

interface LinkCaseButtonProps {
  publication: DJENPublication
  onLinked: () => void | Promise<void>
}

export function LinkCaseButton({ publication, onLinked }: LinkCaseButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsModalOpen(true)}
        disabled={!!publication.linkedCaseId}
      >
        <LinkIcon aria-hidden="true" />
        {publication.linkedCaseId ? 'Já vinculado' : 'Vincular a processo'}
      </Button>

      {isModalOpen && (
        <LinkCaseModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          publication={publication}
          onLinked={async () => {
            await onLinked()
            setTimeout(() => {
              setIsModalOpen(false)
            }, 500)
          }}
        />
      )}
    </>
  )
}
